import { Dashboard } from '@fullstory/proto/fs/services/dx-objects';

export enum DashboardRequestTypes {
  CreateDashboardRequest = 'dashboards.create.request',
  CreateDashboardSuccess = 'dashboards.create.success',
  CreateDashboardFailure = 'dashboards.create.failure',
  DuplicateDashboardRequest = 'dashboards.duplicate.request',
  DuplicateDashboardSuccess = 'dashboards.duplicate.success',
  DuplicateDashboardFailure = 'dashboards.duplicate.failure',
  UpdateDashboardRequest = 'dashboards.update.request',
  UpdateDashboardSuccess = 'dashboards.update.success',
  UpdateDashboardFailure = 'dashboards.update.failure',
  DeleteDashboardRequest = 'dashboards.delete.request',
  DeleteDashboardSuccess = 'dashboards.delete.success',
  DeleteDashboardFailure = 'dashboards.delete.failure',
  BulkDeleteDashboardsRequest = 'dashboards.bulkDelete.request',
  BulkDeleteDashboardsSuccess = 'dashboards.bulkDelete.success',
  BulkDeleteDashboardsFailure = 'dashboards.bulkDelete.failure',
  FetchAllDashboardRequest = 'dashboards.fetchAll.request',
  FetchAllDashboardSuccess = 'dashboards.fetchAll.success',
  FetchAllDashboardFailure = 'dashboards.fetchAll.failure',
  FetchInitialDashboardsRequest = 'dashboards.fetchInitial.request',
  FetchInitialDashboardsSuccess = 'dashboards.fetchInitial.success',
  FetchInitialDashboardsFailure = 'dashboards.fetchInitial.failure',
  FetchDashboardRequest = 'dashboards.fetch.request',
  FetchDashboardSuccess = 'dashboards.fetch.success',
  FetchDashboardFailure = 'dashboards.fetch.failure',
  StarDashboardRequest = 'dashboard.star.request',
  StarDashboardSuccess = 'dashboard.star.success',
  StarDashboardFailure = 'dashboard.star.failure',
  MarkDashboardViewedRequest = 'dashboard.viewed.request',
  MarkDashboardViewedSuccess = 'dashboard.viewed.success',
  MarkDashboardViewedFailure = 'dashboard.viewed.failure',
  DashboardAccessRequest = 'dashboard.access.request',
  DashboardAccessSuccess = 'dashboard.access.success',
  DashboardAccessFailure = 'dashboard.access.failure',
  DashboardTransferOwnerRequest = 'dashboard.transferOwner.request',
  DashboardTransferOwnerSuccess = 'dashboard.transferOwner.success',
  DashboardTransferOwnerFailure = 'dashboard.transferOwner.failure',
  CreateFromVirtualDashboardRequest = 'dashboards.createFromVirtualDashboard.request',
  CreateFromVirtualDashboardSuccess = 'dashboards.createFromVirtualDashboard.success',
  CreateFromVirtualDashboardFailure = 'dashboards.createFromVirtualDashboard.faliure',
  UpdateDashboardAfterCardMove = 'dashboards.updateAfterCardMove',
}

export enum DashboardFilterActionTypes {
  SetSegment = 'SetSegment',
  SetDependentEventFilters = 'SetDependentEventFilters',
  SetOverlay = 'SetOverlay',
  ClearFilters = 'ClearFilters',
  SaveFilters = 'SaveFilters',
}

export enum CardRequestTypes {
  CreateCardRequest = 'dashboards.createCard.request',
  CreateCardSuccess = 'dashboards.createCard.success',
  CreateCardFailure = 'dashboards.createCard.failure',
  UpdateCardRequest = 'dashboards.updateCard.request',
  UpdateCardSuccess = 'dashboards.updateCard.success',
  UpdateCardFailure = 'dashboards.updateCard.failure',
  DeleteCardRequest = 'dashboards.deleteCard.request',
  DeleteCardSuccess = 'dashboards.deleteCard.success',
  DeleteCardFailure = 'dashboards.deleteCard.failure',
  FetchSingleCardRequest = 'dashboards.fetchSingleCard.request',
  FetchSingleCardSuccess = 'dashboards.fetchSingleCard.success',
  FetchSingleCardFailure = 'dashboards.fetchSingleCard.failure',
  DuplicateCardRequest = 'dashboards.duplicateCard.request',
  DuplicateCardSuccess = 'dashboards.duplicateCard.success',
  DuplicateCardFailure = 'dashboards.duplicateCard.failure',
}

export enum ConversionFunnelCardRequestTypes {
  AppCacheRequest = 'conversionfunnelcard/APP_CACHE_REQUEST',
  AppCacheSuccess = 'conversionfunnelcard/APP_CACHE_SUCCESS',
  AppCacheFailure = 'conversionfunnelcard/APP_CACHE_FAILURE',
}

export type DashboardsById = { [id: string]: Dashboard };
